import FontKeys from "./FontKeys";
import Game from "./scenes/Game";
import Intro from "./scenes/Intro";

export default {
    /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
    scenes: [Intro, Game],

    /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
    startScene: Intro.KEY,

    GAME_STATE: "intro", //"intro", "game"
    GAME_PAUSED: false,
    GAME_MODE: "arcade",
    MUTE: false,
    GAME_DONE: false,
    GAME_END: false,
    GAME_LEVEL: 0,
    GAME_FONTS: [FontKeys._linotte_bolduploaded_file, FontKeys._nougatregular],
    CORRECT_SOUNDS:["Gem_1", "Gem_2", "Gem_3", "Gem_4", "Gem_5", "Gem_6", "Gem_7", "Gem_8", "Gem_9", "Gem_10", "Gem_11", "Gem_12"],
    TOTALS:[],
    LEVELS:[],
    SELECTED_GEM: null,
    SPECIAL_GEM: false,
    QUESTIONING: false,
    GRABBING: false,
    INTRO_STEP: 0,
    PREV_GEM: null,
    ANSWER: null,
    INIT_GRAB: false,
    SCORE: 0,
    SPEED: 10000
}
